import React from "react";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { firestoreQuery } from "../../constants";
import { camelCaseToText } from "../../helpers/format";

import { useLoading, useCurrentWsDetail } from "../../firebase";

const baseFields: Record<string, string[]> = {
  item: [
    "name",
    "serialNumber",
    "internalNumber",
    "invoiceNumber",
    "notes",
    "user",
    "bought",
    "warrantyUntil",
    "extendedWarranty",
  ],
  user: ["displayName", "role", "item", "notificationSettings"],
};

interface Props {
  type: "item" | "user";
  value: string;
  onChange: (value: string) => void;
  size?: "small" | "medium";
}

const HistoryFilter: React.FC<Props> = ({ type, value, onChange, size = "small" }) => {
  const { fields } = useCurrentWsDetail();
  const loading = useLoading(firestoreQuery.currentWsDetail);

  const currentBaseFields = baseFields[type];
  const options =
    type === "item" && fields ? currentBaseFields.concat(Object.keys(fields)) : currentBaseFields;

  if (loading) {
    return null;
  }

  return (
    <TextField onChange={(e) => onChange(e.target.value)} select value={value} size={size}>
      <MenuItem key="All" value="All">
        All
      </MenuItem>
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {camelCaseToText(option)}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default HistoryFilter;
